import React, { Component, memo } from "react";
import { TabContent, TabPane } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import settings from "../settings.js";
import ClientBadge from "./ClientBadge";
import dayjs from "dayjs";
import "dayjs/locale/nl"; // Voor Nederlandse datumweergave
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

// Configureer dayjs voor Nederlandse datums
dayjs.locale("nl");

// Create memoized DatePicker component
const MemoizedDatePicker = memo(({ selectedDate, handleDateChange }) => (
  <DatePicker
    selected={selectedDate}
    onChange={handleDateChange}
    dateFormat="dd-MM-yyyy"
    className="form-control"
    placeholderText="Selecteer datum"
    portalId="datepicker-portal"
    popperClassName="datepicker-popper"
    popperPlacement="bottom-start"
  />
));

class DailyOrders extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orders: [],
      activeTab: "1",
      searchProduct: "",
      searchResults: [],
      orderdata: [],
      orderID: 0,
      selectedDate: dayjs().toDate(), // Huidige datum als default
      searchInputValue: "", // Add new state for immediate input value
      selectedVestiging: "all", // Add new state for vestiging filter
    };
  }

  componentDidMount() {
    this.loadOrders(dayjs(this.state.selectedDate).format("YYYY-MM-DD"));
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      // Reset search when going back to tab "1"
      if (tab === "1") {
        this.setState({
          activeTab: tab,
          searchProduct: "",
          searchInputValue: "",
          searchResults: [],
        });
      } else {
        this.setState({
          activeTab: tab,
        });
      }
    }
  };

  handleDateChange = (date) => {
    // First blur the input
    document.activeElement.blur();

    // Use setTimeout to ensure state updates happen after blur
    setTimeout(() => {
      this.setState({ selectedDate: date }, () => {
        this.loadOrders(dayjs(date).format("YYYY-MM-DD"));
      });
    }, 0);
  };

  loadOrders(date) {
    this.props.loading(true);
    console.log(date);
    fetch(
      settings.server_url +
        "get_deliveries/" +
        window.sessionStorage.getItem("sid") +
        "/" +
        dayjs(this.state.selectedDate).format("YYYY-MM-DD")
    )
      .then((res) => res.json())
      .then((response) => {
        this.setState({ orders: response });
        this.props.loading(false);
        this.props.addBreadcrumb([
          { name: "Leveringen", url: "/orders", reset: false },
        ]);
        // Ensure input stays blurred after loading
        document.activeElement.blur();
      })
      .catch((error) => {
        console.error("Error:", error);
        this.props.loading(false);
        // Also ensure input stays blurred on error
        document.activeElement.blur();
      });
  }

  loadOrder = (e, orderid, clientid) => {
    e.preventDefault();
    this.props.addBreadcrumb([
      { name: "Order " + orderid, url: "/orders", reset: true },
    ]);

    this.setState({ orderdata: [], orderID: orderid });
    this.props.loading(true);
    this.toggle("2");
    fetch(
      settings.server_url +
        "get_order/" +
        window.sessionStorage.getItem("sid") +
        "/" +
        clientid +
        "/" +
        orderid
    )
      .then((res) => res.json())
      .then((response) => {
        this.setState({ orderdata: response });
        this.props.loading(false);
      })
      .catch((error) => console.error("Error:", error));
  };

  loadSearchOrders = (e) => {
    e.preventDefault();
    this.toggle("3");

    // Filter the orders array based on searchProduct
    const filteredResults = this.state.orders.filter((order) => {
      const searchTerm = this.state.searchProduct.toLowerCase();
      return (
        order.orderrow_name.toLowerCase().includes(searchTerm) ||
        order.orderrow_art_nr.toLowerCase().includes(searchTerm)
      );
    });

    this.setState({ searchResults: filteredResults });
  };

  searchProduct = (e) => {
    e.preventDefault();
    // Update the input value immediately without triggering search
    this.setState({ searchInputValue: e.target.value });
  };

  handleSearch = (e) => {
    e.preventDefault();
    // Only update search term when search is triggered
    this.setState({ searchProduct: this.state.searchInputValue }, () => {
      this.loadSearchOrders(e);
    });
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.handleSearch(e);
    }
  };

  getDeliveryNoteLink(orderid) {
    return (
      settings.server_url +
      "get_pdf_delivery_note/" +
      window.sessionStorage.getItem("sid") +
      "/" +
      orderid
    );
  }

  // Add method to get all available vestigingen
  getAllVestigingen = () => {
    const allVestigingen = [
      { id: 10, name: "Koel & Vries" },
      { id: 11, name: "Centraal magazijn" },
      { id: 29, name: "Apparaten" },
      { id: 54, name: "Dagvers" },
      { id: 69, name: "Versmarkt" },
      { id: 61, name: "Vis" },
      { id: 120, name: "Valk en Vlees" },
    ];
    return allVestigingen.sort((a, b) => a.name.localeCompare(b.name));
  };

  // Add method to handle vestiging filter change
  handleVestigingChange = (e) => {
    this.setState({ selectedVestiging: e.target.value });
  };

  // Add method to get filtered orders based on vestiging
  getFilteredOrders = () => {
    if (this.state.selectedVestiging === "all") {
      return this.state.orders;
    }
    return this.state.orders.filter(
      (order) =>
        order.order_vestiging_id.toString() === this.state.selectedVestiging
    );
  };

  status(status) {
    let statusbadge;

    switch (parseInt(status)) {
      case 0:
        statusbadge = (
          <div className="text-primary">
            <i className="fas fa-star mr-3" />
            Nieuw
          </div>
        );
        break;
      case 4:
        statusbadge = (
          <div className="text-muted">
            <i className="far fa-clock mr-3" />
            In behandeling
          </div>
        );
        break;
      case 5:
        statusbadge = (
          <div className="text-warning">
            <i className="fas fa-truck mr-3" />
            Onderweg
          </div>
        );
        break;
      case 1:
        statusbadge = (
          <div className="text-success">
            <i className="far fa-check-square mr-3" />
            Afgeleverd
          </div>
        );
        break;
      case 3:
        statusbadge = (
          <div className="text-success">
            <i className="far fa-check-square mr-3" />
            Afgeleverd
          </div>
        );
        break;
      case 7:
        statusbadge = (
          <div className="text-success">
            <i className="far fa-check-square mr-3" />
            Afgeleverd
          </div>
        );
        break;
      case 9:
        statusbadge = (
          <div className="text-muted">
            <i className="far fa-clock mr-3" />
            In behandeling
          </div>
        );
        break;
      case 13:
        statusbadge = (
          <div className="text-muted">
            <i className="far fa-clock mr-3" />
            In behandeling
          </div>
        );
        break;
      case 19:
        statusbadge = (
          <div className="text-muted">
            <i className="far fa-clock mr-3" />
            Klaar voor leveren
          </div>
        );
        break;
      case 20:
        statusbadge = (
          <div className="text-success">
            <i className="far fa-check-square mr-3" />
            Afgeleverd
          </div>
        );
        break;
      case 14:
        statusbadge = (
          <div className="text-info">
            <i className="far fa-angle-double-right mr-3" />
            Rechtstreeks
          </div>
        );
        break;

      default:
        statusbadge = (
          <div className="text-primary">
            <i className="fas fa-star mr-3" />?
          </div>
        );
    }
    return statusbadge;
  }

  render() {
    const filteredOrders = this.getFilteredOrders();
    const allVestigingen = this.getAllVestigingen();

    return (
      <TabContent activeTab={this.state.activeTab}>
        <TabPane tabId="1">
          <div className="form-inline orderheader px-3 py-4">
            <div className="w-100">
              <div className="float-left d-flex flex-wrap flex-md-nowrap">
                <div className="input-group mr-3">
                  <MemoizedDatePicker
                    selectedDate={this.state.selectedDate}
                    handleDateChange={this.handleDateChange}
                  />
                </div>
                <div className="input-group searchicon">
                  <input
                    type="text"
                    className="form-control input-search pr-5"
                    name="search"
                    placeholder="Zoek een product..."
                    autoComplete="off"
                    value={this.state.searchInputValue}
                    onChange={this.searchProduct}
                    onKeyDown={this.handleKeyDown}
                  />
                  <button
                    type="button"
                    onClick={this.handleSearch}
                    className="btn btn btn-outline-primary ml-2">
                    <i className="far fa-search" /> Zoeken
                  </button>
                </div>
                <div className="input-group ml-3">
                  <select
                    className="form-control"
                    value={this.state.selectedVestiging}
                    onChange={this.handleVestigingChange}>
                    <option value="all">Alle afdelingen</option>
                    {allVestigingen.map((vestiging) => (
                      <option
                        key={vestiging.id}
                        value={vestiging.id.toString()}>
                        {vestiging.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="float-right mt-3 mt-md-0">
                <div className="border border-primary btn btn-link">
                  <i className="far fa-file-export mr-2" />
                  Lijst exporteren
                </div>
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <Table className="table table-hover mb-0 border bg-white">
              <Thead>
                <Tr>
                  <Th className="text-left text-muted">AFBEELDING</Th>
                  <Th className="text-left text-muted">ARTIKEL NAAM</Th>
                  <Th className="text-left text-muted">ARTIKEL #</Th>
                  <Th className="text-center text-muted">AANTAL</Th>
                  <Th className="text-left text-muted">AFDELING</Th>
                  <Th className="text-left text-muted">PARTNER</Th>
                  <Th className="text-left text-muted">ORDER #</Th>
                  <Th className="text-left text-muted">ORDERDATUM</Th>
                  <Th />
                </Tr>
              </Thead>
              {filteredOrders.length > 0 ? (
                <Tbody>
                  {filteredOrders.map((order, i) => {
                    return (
                      <Tr key={order.orderrow_id} className="historyrow">
                        <Td className="align-middle">
                          {order.image ? (
                            <img
                              src={order.image}
                              alt=""
                              className="max50 img-fluid"
                            />
                          ) : (
                            <span className="image_placeholder" />
                          )}
                        </Td>
                        <Td className="text-left align-middle text-truncate">
                          {order.orderrow_name}
                        </Td>
                        <Td className="text-left align-middle">
                          {order.orderrow_art_nr}
                        </Td>
                        <Td className="text-center align-middle">
                          {order.orderrow_quantity}
                        </Td>
                        <Td className="text-left align-middle text-truncate">
                          <ClientBadge
                            clientId={order.order_vestiging_id}
                            partner={order.partner}
                          />
                        </Td>
                        <Td className="text-left align-middle">
                          {order.partner ? order.partner_name : ""}
                        </Td>
                        <Td className="text-left align-middle">
                          <a
                            href="#"
                            onClick={(e) => {
                              this.loadOrder(
                                e,
                                order.order_id,
                                order.order_vestiging_id
                              );
                            }}>
                            {order.order_id}
                          </a>
                        </Td>
                        <Td className="text-left align-middle">
                          {order.order_date}
                        </Td>
                        <Td className="align-middle">
                          <a
                            href={this.getDeliveryNoteLink(order.order_id)}
                            target="_blank"
                            rel="noopener noreferrer">
                            <i className="fal fa-print" />
                          </a>
                        </Td>
                      </Tr>
                    );
                  })}
                </Tbody>
              ) : (
                <Tbody>
                  <Tr>
                    <Td colSpan="9" className="text-center py-4">
                      {this.state.selectedVestiging === "all"
                        ? "Geen levering gevonden op deze datum"
                        : "Geen levering gevonden voor deze afdeling op deze datum"}
                    </Td>
                  </Tr>
                </Tbody>
              )}
            </Table>
          </div>
        </TabPane>
        <TabPane tabId="2">
          <div className="align-items-center d-flex orderheader p-3 text-left">
            <div className="">
              <div
                className="btn btn-link p-2"
                onClick={(e) => {
                  e.preventDefault();
                  this.toggle("1");
                }}>
                <i className="fal fa-arrow-left mr-2" />
                Terug naar overzicht
              </div>
              <div className="font-weight-bold">Order {this.state.orderID}</div>
            </div>
            <div className="ml-auto">
              <div className="border border-primary  btn btn-link">
                <i className="far fa-file-export mr-2" />
                Lijst exporteren
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <Table className="table table-hover table-striped mb-0 border bg-white">
              <Thead>
                <Tr>
                  <Th className="text-left text-muted">Product</Th>
                  <Th className="text-left" />
                  <Th className="text-center text-muted">Artikelnr</Th>
                  <Th className="text-center text-muted">Eenheid</Th>
                  <Th className="text-center text-muted">Aantal</Th>
                </Tr>
              </Thead>
              <Tbody>
                {this.state.orderdata.map((order, i) => {
                  return (
                    <Tr key={i}>
                      <Td className="align-middle hidden">
                        {order.image > "" ? (
                          <img
                            src={order.image}
                            alt=""
                            className="max50 img-fluid"
                          />
                        ) : (
                          <span className="image_placeholder" />
                        )}
                      </Td>
                      <Td className="align-middle text-left">
                        <strong>{order.orderrow_name}</strong>
                      </Td>
                      <Td className="align-middle">{order.orderrow_art_nr}</Td>
                      <Td className="align-middle">
                        <div className="unit">
                          <span>{order.orderrow_unit}</span>
                        </div>
                      </Td>
                      <Td className="align-middle">
                        {parseFloat(order.orderrow_quantity)
                          .toString()
                          .replace(".", ",")}
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </div>
        </TabPane>
        <TabPane tabId="3">
          <div className="form-inline orderheader px-3 py-4">
            <div className="w-100">
              <div className="float-left d-flex flex-wrap flex-md-nowrap">
                <div className="input-group">
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      this.toggle("1");
                    }}
                    className="btn btn btn-outline-primary">
                    <i className="fal fa-long-arrow-left" /> Terug
                  </button>
                </div>
                <div className="input-group searchicon">
                  <input
                    type="text"
                    className="form-control input-search mx-md-3 pr-5"
                    name="search"
                    placeholder="Zoek een product..."
                    autoComplete="off"
                    value={this.state.searchInputValue}
                    onChange={this.searchProduct}
                    onKeyDown={this.handleKeyDown}
                  />
                  <button
                    type="button"
                    onClick={this.handleSearch}
                    className="btn btn btn-outline-primary">
                    <i className="far fa-search" /> Zoeken
                  </button>
                </div>
              </div>
              <div className="float-right mt-3 mt-md-0">
                <div className="border border-primary  btn btn-link">
                  <i className="far fa-file-export mr-2" />
                  Lijst exporteren
                </div>
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <Table className="table table-hover mb-0 border bg-white">
              <Thead>
                <Tr>
                  <Th className="text-left text-muted">ARTIKEL #</Th>
                  <Th className="text-left text-muted">ARTIKEL</Th>
                  <Th className="text-left text-muted">AFDELING</Th>
                  <Th className="text-left text-muted">AANTAL</Th>
                  <Th className="text-left text-muted">LEVERDATUM</Th>
                  <Th className="text-left text-muted">STATUS</Th>
                  <Th />
                </Tr>
              </Thead>
              <Tbody>
                {this.state.searchResults.map((row, i) => {
                  return (
                    <Tr key={i} className="historyrow">
                      <Td className="text-left align-middle">
                        {row.orderrow_art_nr}
                      </Td>
                      <Td className="text-left align-middle text-truncate">
                        {row.orderrow_name}
                      </Td>
                      <Td className="text-left align-middle text-truncate">
                        <ClientBadge clientId={row.order_vestiging_id} />
                      </Td>
                      <Td className="text-right align-middle">
                        {row.orderrow_quantity}
                      </Td>
                      <Td className="text-left align-middle">
                        {row.order_delivery_moment}
                      </Td>
                      <Td className="text-left align-middle">
                        {this.status(row.order_status)}
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </div>
        </TabPane>
      </TabContent>
    );
  }
}

export default DailyOrders;
